import React from 'react';
import PricingPlansPanel from './PricingPlansPanel';
import ComparePlansPanel from './ComparePlansPanel';
import ApiIntegrationPanel from './ApiIntegrationPanel';
import RequestServiceModalProvider from '@/finsight/application/RequestServiceModalContext';
import FaqPanel from './FaqPanel';

import styles from './styles.scss';

const Pricing = () => {
  return (
    <RequestServiceModalProvider>
      <div className={ styles.pricingContainer }>
        <PricingPlansPanel />
        <ComparePlansPanel />
        <ApiIntegrationPanel />
        <FaqPanel />
      </div>
    </RequestServiceModalProvider>
  );
};

export default Pricing;
